export default "__VITE_ASSET__TswAkWK9__"